import { ModuleTypeSelectionWidget, ShopSelectionWidget } from 'components/FormWidget';
const uiSchema = () => ({
  shop_id: {
    'ui:widget': ShopSelectionWidget,
  },
  type_id: {
    'ui:widget': ModuleTypeSelectionWidget,
  },
  text: {
    'ui:widget': 'textarea',
  },
});

export default uiSchema;
